import { render, staticRenderFns } from "./CartListProduct.vue?vue&type=template&id=0b88ff31"
import script from "./CartListProduct.vue?vue&type=script&lang=js"
export * from "./CartListProduct.vue?vue&type=script&lang=js"
import style0 from "./CartListProduct.vue?vue&type=style&index=0&id=0b88ff31&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports